<template>
<div>
  <div class="splash" v-if="!preloadDone">
    <div class="container  d-flex h-100">
      <div class="row justify-content-center text-primary w-100 align-self-center text-white">
        <i class="fa fa-spin fa-spinner"></i>
      </div>
    </div>
  </div>
  <div v-if="preloadDone">
    <b-card class="mt-1">
      <div class="text-right queries-toolbar">
        <a v-if="!showResults" href v-on:click.prevent="openLoadQueryPopup"><i class="fa fa-folder-open"></i></a>
        <a href v-on:click.prevent="openSaveQueryPopup"><i class="fa fa-save"></i></a>
        <a href v-on:click.prevent="shareQuery"><i class="fa fa-share-alt"></i></a>
      </div>
      <div v-if="!showResults">

        <div class="toolbar">
          <div class="row">
            <div class="col-md-2">
              <b-form-group label="Tipo de comparação">
                <b-form-radio-group id="radioDates" button-variant="outline-primary" buttons size="sm" v-model="readOptions.datetype" :options="periodType" name="radiosBtnDatesType" />
              </b-form-group>
            </div>
            <div class="col-md-1">
              <b-form-group label="Ano">
                <b-form-select v-model="readOptions.year" :options="years">
                </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-3">
              <b-form-group label="Intervalo">
                <b-form-radio-group id="datesOptions" button-variant="outline-primary" buttons size="sm" v-model="readOptions.presetdate" :options="datesOptions" name="radiosBtndatesOptions" />
              </b-form-group>
            </div>


            <div class="col-md-6" v-if="readOptions.presetdate==='custom'">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-group label="De">
                    <div class="form-inline">
                      <b-form-select v-model="readOptions.dates.start.day" :options="days">
                      </b-form-select> /
                      <b-form-select v-model="readOptions.dates.start.month" :options="months">
                      </b-form-select>
                    </div>
                  </b-form-group>
                </div>
                <div class="col-sm-3">
                  <b-form-group label="a">
                    <div class="form-inline">
                      <b-form-select v-model="readOptions.dates.end.day" :options="days">
                      </b-form-select> /
                      <b-form-select v-model="readOptions.dates.end.month" :options="months">
                      </b-form-select>
                    </div>
                  </b-form-group>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Variável a analisar">
              <b-form-radio-group id="btnradios1" button-variant="outline-primary" buttons size="sm" v-model="readOptions.columns" :options="variables" name="radiosBtnVars" />
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Tipo de cliente">
              <b-form-radio-group id="btnradiosclitype" button-variant="outline-primary" buttons size="sm" v-model="readOptions.clientType" :options="clientTypes" name="radiosBtnVars" />
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Tipo de encomenda">
              <b-form-radio-group id="btnradiosclitype" button-variant="outline-primary" buttons size="sm" v-model="readOptions.orderType" :options="orderTypes" name="radiosBtnVars" />
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group label="Tipo de documento">
              <b-form-radio-group id="btnradiodoctype" button-variant="outline-primary" buttons size="sm" v-model="readOptions.docType" :options="documentTypes" name="radiosBtnVars" />
            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <b-form-group label="Mostrar em linha">
              <b-form-radio-group id="btnradios2" button-variant="outline-primary" buttons size="sm"  v-model="readOptions.rows" :options="rows" name="radiosRows" />
            </b-form-group>
          </div>
          <b-col md="9">
            <div>
              <b-form-group label="Detalhe">
                <b-form-radio-group id="btnradios3" buttons size="sm" button-variant="outline-primary" v-model="readOptions.subrows" :options="subrows" name="radiosSubRows" />
              </b-form-group>
            </div>
            <div>
              <b-form-group label="Agrupar por">
                <b-form-radio-group id="btnradios4" buttons size="sm" button-variant="outline-primary" v-model="readOptions.groupby" :options="groups" name="radiosSubRows" />
              </b-form-group>
            </div>
          </b-col>

        </div>

        <div>
          <b-button variant="success" :disabled="loadingResults" class="btn-block" size="lg" v-on:click="showData()"><i v-bind:class="{'fa-search': !loadingResults, 'fa-spinner': loadingResults, 'fa-spin': loadingResults}" class="fa fa-search"></i> Pesquisar</b-button>
        </div>
        <b-alert class="mt-3" variant="danger" :show="queryErrorShow" dismissible>
          <h4 class="alert-heading">Erro</h4> Houve um erro com a sua pesquisa
        </b-alert>
      </div>
      <div v-if="showResults">
        <div class="row">
          <div class="col-sm-9">
            <div>A analisar: <strong>{{ columnsName }}</strong> por <strong>{{ rowsText }}</strong> <span v-if="readOptions.groupby !== 'none'"> agrupado por <strong>{{groupByName}}</strong></span> | <a href="#" v-scroll-to="'#filters-grid'"><strong>{{ totalFilters }}</strong> filtros</a>
            </div>
            <div v-html="datesText"></div>
          </div>
          <div class="col-sm-3">
            <b-button class="pull-right btn-block" variant="warning" size="lg" v-on:click="showForm()">Alterar</b-button>
          </div>
        </div>
      </div>
    </b-card>
    <fullscreen :fullscreen.sync="fullscreenGrid">
      <div id="statistics-results" class="statistics-results" v-if="showResults">
        <b-card no-body>
          <b-card-header class="text-right">
            <a href="#" v-if="$auth.check(['all.export', 'dim.export'])"  @click="exportResults"><i class="fa fa-download"></i> exportar</a> |
            <a href="#" @click="toggleFullscreen"><i class="fa fa-expand"></i> fullscreen</a>
          </b-card-header>
          <kendo-tooltip :content="getTooltipContents" :width="200" :filter="'.value-cell'">
            <statistics-grid :rows="rows" :groupDefinition="groupDefinition" :aggregateDefinition="aggregateDefinition" ref="statsGrid" v-bind:query="readOptions" v-if="loaded" name="statisticsGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true'
              :sortable='true' v-bind:schemaModelFields="schemaModelFields" v-bind:schemaModelId="'id'" v-bind:preload="preload" :details="details" v-on:ds-error="loadingError"></statistics-grid>
          </kendo-tooltip>
        </b-card>
      </div>
    </fullscreen>

    <filters id="filters-grid" ref="filtersPane" :filters="filterOptions" :showFilterGrid="showFilterGrid" :showResults="showResults" :totalFilters="totalFilters" :readOptions="readOptions"></filters>
  </div>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="hideModal">
        Close
      </b-btn>
    </div>
  </b-modal>
  <b-modal ref="saveModal" id="saveModal" title="Gravar pesquisa">
    <b-form @submit="saveQuery">
      <b-form-input v-model="queryName" ref="queryName" type="text"></b-form-input>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-left" variant="secondary" @click="hideSaveModal">
        Close
      </b-btn>
      <b-btn size="sm" class="float-right" variant="success" @click="saveQuery">
        <i class="fa fa-save-o"></i> Gravar
      </b-btn>
    </div>
  </b-modal>
  <b-modal ref="shareModal" id="shareModal">
    <b-form>
      <b-form-input v-model="queryUrl" readonly ref="queryName" type="text"></b-form-input>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-left" variant="secondary" @click="hideShareModal">
        Close
      </b-btn>
    </div>
  </b-modal>
  <b-modal @shown="showQueries=true" @hidden="showQueries=false" size="lg" ref="loadQueryModal" id="loadQueryModal">
    <UserQueries v-if="showQueries" height="400" v-on:load-query="loadUserQuery" />
  </b-modal>
</div>
</template>
<script>
import Vue from 'vue'
import Filters from '@/views/Statistics/Filters.vue'
import UserQueries from '@/views/Statistics/UserQueries.vue'
import fullscreen from 'vue-fullscreen'

// import kendo from '@progress/kendo-ui/js/kendo.all.js'
import {
  PopupsInstaller
} from '@progress/kendo-popups-vue-wrapper'

Vue.use(PopupsInstaller)
Vue.use(fullscreen)
export default {
  name: 'Statistics',
  components: {
    Filters,
    UserQueries
  },
  data() {
    return {
      preload: [],
      schemaModelFields: {},
      url: 'statistics',
      loadingResults: false,
      queryErrorShow: false,
      readOptions: {
        columns: 'gsv',
        rows: 'products',
        subrows: 'product_aggregator_id',
        groupby: 'none',
        presetdate: 'today',
        datetype: 'y',
        year: 2026,
        clientType: 'A',
        orderType: 'A',
        docType: 'AGR',
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      },
      clientTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'F',
        text: 'Fatura'
      }, {
        value: 'G',
        text: 'Guias'
      }],
      orderTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'Offline',
        text: 'Offline'
      }, {
        value: 'Online',
        text: 'Online'
      }],
      documentTypes: [{
        value: 'A',
        text: 'Todos'
      }, {
        value: 'AGR',
        text: 'Sem guias'
      }, {
        value: 'SG',
        text: 'Só guias'
      }],
      aggregateDefinition: [],
      details: [],
      columns: [],
      preloadDone: false,
      loaded: false,
      showFilterType: '',
      showFilterGrid: true,
      showResults: false,
      tableInitialized: false,
      fullscreenGrid: false,
      exporting: false,
      showQueries: false,
      fileDownload: '',
      variables: [],
      rows: [],
      subrows: [],
      groups: [],
      queryName: '',
      queryUrl: '',
      years: [{
        value: 2022,
        text: '2022'
      }, {
        value: 2023,
        text: '2023'
      }, {
        value: 2024,
        text: '2024'
      }, {
        value: 2025,
        text: '2025'
      }, {
        value: 2026,
        text: '2026'
      }],
      days: [],
      months: [{
        value: 1,
        text: 'Jan.'
      }, {
        value: 2,
        text: 'Fev.'
      }, {
        value: 3,
        text: 'Mar.'
      }, {
        value: 4,
        text: 'Abr.'
      }, {
        value: 5,
        text: 'Mai.'
      }, {
        value: 6,
        text: 'Jun.'
      }, {
        value: 7,
        text: 'Jul.'
      }, {
        value: 8,
        text: 'Ago.'
      }, {
        value: 9,
        text: 'Set.'
      }, {
        value: 10,
        text: 'Out.'
      }, {
        value: 11,
        text: 'Nov.'
      }, {
        value: 12,
        text: 'Dez.'
      }],
      filterOptions: [],
      datesOptions: [{
        text: 'até ontem',
        value: 'today'
      }, {
        text: 'Q1',
        value: 'q1'
      }, {
        text: 'Q2',
        value: 'q2'
      }, {
        text: 'Q3',
        value: 'q3'
      }, {
        text: 'Q4',
        value: 'q4'
      }, {
        text: 'customizado',
        value: 'custom'
      }],
      periodType: [{
        value: 'y',
        text: 'Ano'
      }, {
        value: 'ym',
        text: 'Ano / Mês'
      }]
    }
  },
  methods: {
    showData() {
      this.loaded = false
      this.loadingResults = true
      this.queryErrorShow = false
      this.showFilterGrid = false
      this.showResults = false
      this.axios.post('statistics/columns', this.readOptions).then(response => {
        this.columns = response.data.data.columns
        this.aggregateDefinition = response.data.data.aggregates
        this.groupDefinition = response.data.data.groups
        this.schemaModelFields = response.data.data.fields

        if (!this.tableInitialized) {
          this.loaded = true
          this.showResults = true
        } else {
          this.$refs.statsGrid.refresh()
          this.showResults = true
          this.loaded = true
        }
        var that = this
        setTimeout(function() {
          that.$scrollTo('#statistics-results', 300, {
            offset: -60
          })
        }, 100)
      })
    },
    showForm() {
      this.loaded = false
      this.showResults = false
      this.showFilterGrid = true
      this.loadingResults = false
    },
    loadingError(e) {
      this.loaded = false
      this.loadingResults = false
      this.showFilterGrid = true
      this.showResults = false
      this.queryErrorShow = true
    },
    changedRows() {
      this.subrows = this.rows[this.readOptions.rows].sub
      this.readOptions.subrows = this.rows[this.readOptions.rows].default
      this.details = this.subrows[this.readOptions.subrows].details
      this.setGroups()
    },
    setGroups() {
      this.groups = []
      var g = this.subrows[this.readOptions.subrows].groupby
      this.groups.push({
        value: 'none',
        text: 'Consolidado'
      })
      // this.readOptions.groupby = 'none'
      var active = false
      for (var i = 0; i < g.length; i++) {
        this.groups.push(g[i])
        if (this.readOptions.groupby === g[i].value) {
          active = true
        }
      }
      if (!active) {
        this.readOptions.groupby = 'none'
      }
    },
    changedSubRows() {
      this.details = this.subrows[this.readOptions.subrows].details
      this.groups = []
      this.setGroups()
    },
    exportResults(e) {
      e.preventDefault()
      this.exporting = true
      this.axios.post('statistics/export', this.readOptions).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      })
    },
    toggleFullscreen() {
      this.fullscreenGrid = !this.fullscreenGrid
    },
    hideModal: function() {
      this.$refs.downloadModal.hide()
    },
    hideSaveModal: function() {
      this.$refs.saveModal.hide()
    },
    hideShareModal: function() {
      this.$refs.shareModal.hide()
    },
    getTooltipContents: function(e) {
      return e.target.data('past') + '<br>' + e.target.data('current') + '<br>' + e.target.data('dif')
    },
    getQuery(queryId) {
      this.axios.get('queries/' + queryId).then(response => {
        this.loadQuery(response.data.data)
      })
    },
    openSaveQueryPopup() {
      this.$refs.saveModal.show()
    },
    openLoadQueryPopup() {
      this.$refs.loadQueryModal.show()
    },
    shareQuery() {
      this.axios.post('queries', this.readOptions).then(response => {
        var route = this.$router.resolve({
          name: 'statistics.index',
          params: {
            id: response.data.data.uuid
          }
        })
        this.queryUrl = window.location.origin + route.href
        this.$refs.shareModal.show()
      })
    },
    saveQuery() {
      this.axios.post('userqueries', {
        query: this.readOptions,
        name: this.queryName
      }).then(response => {
        this.$router.replace({
          name: 'statistics.index',
          params: {
            id: response.data.data.uuid
          }
        })
        this.hideSaveModal()
      })
    },
    loadUserQuery(evt) {
      this.$router.push({
        name: 'statistics.index',
        params: {
          id: (evt.item.uquery.data.uuid)
        }
      })
      if (this.$route.params.id === evt.item.uquery.data.uuid) {
        this.axios.get('queries/' + evt.item.uquery.data.uuid).then(response => {
          this.loadQuery(response.data.data)
        })
      }
      // this.loadQuery(evt.item.uquery.uuid)
      this.$refs.loadQueryModal.hide()
    },
    loadQuery(data) {
      this.readOptions.presetdate = data.presetdate
      this.readOptions.datetype = data.datetype
      this.readOptions.dates = data.dates
      this.readOptions.year = data.year
      this.readOptions.columns = data.columns
      this.readOptions.docType = data.docType
      this.readOptions.clientType = data.clientType
      this.readOptions.orderType = data.orderType
      this.readOptions.rows = data.rows
      var that = this
      setTimeout(function() {
        that.readOptions.subrows = data.subrows
        that.readOptions.groupby = data.groupby
      }, 100)
      setTimeout(function() {
      }, 100)
      this.readOptions.filters = data.filters
    }
  },
  computed: {
    columnsName() {
      return this.variables[this.readOptions.columns].text
    },
    datesText() {
      var txt = 'Ano: <strong>' + this.readOptions.year + '</strong> vs <strong>' + (this.readOptions.year - 1) + '</strong> '
      txt += 'período: <strong>'
      switch (this.readOptions.presetdate) {
        case 'today':
          txt += ' do início do ano até ontem'
          break
        case 'q1':
          txt += ' 1º trimestre'
          break
        case 'q2':
          txt += ' 2º trimestre'
          break
        case 'q3':
          txt += ' 3º trimestre'
          break
        case 'q4':
          txt += ' 4º trimestre'
          break
        case 'custom':
          txt += ' de ' + this.readOptions.dates.start.day + '/' + this.readOptions.dates.start.month
          txt += ' a ' + this.readOptions.dates.end.day + '/' + this.readOptions.dates.end.month
      }
      txt += '</strong>'
      return txt
    },
    groupByName() {
      var sub = this.rows[this.readOptions.rows].sub
      var groups = sub[this.readOptions.subrows].groupby
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].value === this.readOptions.groupby) {
          return groups[i].text
        }
      }
      return ''
    },
    rowsText() {
      var sub = this.rows[this.readOptions.rows].sub
      return sub[this.readOptions.subrows].text + ' (' + this.rows[this.readOptions.rows].text + ')'
    },
    totalFilters() {
      var total = 0
      for (var i = 0; i < this.readOptions.filters.length; i++) {
        total += this.readOptions.filters[i].includes.length
        total += this.readOptions.filters[i].excludes.length
      }
      return total
    }
  },
  watch: {
    'readOptions.rows': function(val, oldVal) {
      this.changedRows()
    },
    'readOptions.subrows': function(val, oldVal) {
      this.changedSubRows()
    }
  },
  beforeRouteUpdate(to, from, next) {
    // react to route changes...
    // don't forget to call next()
    if (to.params.id !== 'index') {
      this.axios.get('queries/' + to.params.id).then(response => {
        this.loadQuery(response.data.data)
        next()
      })
    } else {
      this.readOptions = {
        columns: 'gsv',
        rows: 'products',
        subrows: 'product_aggregator_id',
        groupby: 'none',
        presetdate: 'today',
        datetype: 'y',
        clientType: 'A',
        orderType: 'A',
        docType: 'AGR',
        year: 2020,
        dates: {
          start: {
            day: 1,
            month: 1
          },
          end: {
            day: 31,
            month: 12
          }
        },
        filters: []
      }
      next()
    }
  },
  created() {
    for (var i = 1; i <= 31; i++) {
      this.days.push({
        value: i,
        text: i
      })
    }
    var today = new Date()
    var apiPreloads = [{
      url: 'statistics/variables',
      callback: setVariables
    },
    {
      url: 'statistics/rows',
      callback: setRows
    },
    {
      url: 'statistics/filters',
      callback: setFilters
    }]
    if (typeof this.$route.params.id !== 'undefined' && this.$route.params.id !== 'index') {
      apiPreloads.push({
        url: 'queries/' + this.$route.params.id,
        callback: this.loadQuery
      })
    }
    var that = this
    this.axios.all(apiPreloads.map(l => this.axios.get(l.url))).then(
      that.axios.spread(function() {
        for (var i = 0; i < apiPreloads.length; i++) {
          apiPreloads[i].callback(arguments[i].data.data)
        }
        that.preloadDone = true
      })
    ).catch(response => {
      console.error('error loading foreigns', response)
    })

    function setVariables(response) {
      that.variables = response
    }

    function setRows(response) {
      that.rows = response
      that.subrows = that.rows[that.readOptions.rows].sub
      that.readOptions.subrows = that.rows[that.readOptions.rows].default
      that.details = that.subrows[that.readOptions.subrows].details
      that.setGroups()
    }

    function setFilters(response) {
      that.filterOptions = response
    }
    this.readOptions.dates.end.day = today.getDate()
    this.readOptions.dates.end.month = today.getMonth() + 1
  }
}
</script>



// WEBPACK FOOTER //
// Statistics.vue?2c9e949c